<template>
  <div class="archive20250917" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} 第27回日本感性工学会大会 ポスター発表報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2025年9月17日から19日に実施された第27回日本感性工学会大会でポスター発表しました．</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">
                発表題目：「モダリティ間の違いがうつ状態に与える影響」<br>
                発表題目：「楽曲，歌詞，検索クエリの印象推定に基づく感性楽曲検索手法」
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20250917_1.png`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20250917_2.png`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>
